import React, { FunctionComponent } from 'react'
import { useDispatch } from 'react-redux'
import { Link as ScrollLink } from 'react-scroll'
import {
  IconButton,
  Button,
  ListItem,
  Drawer,
  List,
  Divider,
  Hidden,
} from '@material-ui/core'
import { Cancel } from '@material-ui/icons'
import { LANGUAGE } from 'constants/language'
import { DRAWER } from 'constants/drawer'
import { closeDrawer } from 'actions'
import useStyles from './style'
import { ScrollSettings } from 'text/part'
import { useSelector } from 'hook'
import { TranslateButton, ChangeFontSizeButton } from 'components/Parts'

const MainMenu = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const languageManager = useSelector((state) => state.languageManager)
  const isJP = languageManager === LANGUAGE.JP
  const drawerManager = useSelector((state) => state.drawerManager)
  const open = drawerManager === DRAWER.OPEN

  const LinkButton: FunctionComponent<{ to: string }> = ({ to, children }) => {
    return (
      <ScrollLink
        to={to}
        activeClass="active"
        spy={true}
        smooth={true}
        offset={-70}
        className={classes.menu_wrapper}
      >
        <Button
          onClick={() => {
            dispatch(closeDrawer())
          }}
          className={classes.menu_text}
        >
          {children}
        </Button>
      </ScrollLink>
    )
  }

  const DrawerContent = () => {
    return (
      <>
        <TranslateButton />
        <Divider />
        <ChangeFontSizeButton />
        <Divider />
        <List className={classes.menu_list}>
          {ScrollSettings.map((dest, i) => (
            <div key={i}>
              <ListItem className={classes.menu_item}>
                <LinkButton to={dest.to}>
                  {isJP ? dest.text.jp : dest.text.en}
                </LinkButton>
              </ListItem>
              <Divider light />
            </div>
          ))}
        </List>
      </>
    )
  }

  return (
    <>
      <Hidden smUp>
        <Drawer
          anchor="left"
          open={open}
          onClose={() => {
            dispatch(closeDrawer())
          }}
          classes={{ paper: classes.paper }}
        >
          <IconButton
            className={classes.button_close}
            onClick={() => {
              dispatch(closeDrawer())
            }}
          >
            <Cancel fontSize="large" />
          </IconButton>
          <Divider />
          <DrawerContent />
        </Drawer>
      </Hidden>
      <Hidden xsDown>
        <Drawer
          anchor="left"
          open
          classes={{ paper: classes.paper }}
          variant="permanent"
        >
          <DrawerContent />
        </Drawer>
      </Hidden>
    </>
  )
}

export default MainMenu
